import { combineReducers } from 'redux';
import actionTypes from './actionTypes';

import { REDUCER_NAME } from './constants';
import { REDUCER_NAME as CREDIT_TERMS_REDUCER_NAME } from './creditTerms/constants';
import creditTermsReducer from './creditTerms/reducer';

const initialState = {
  isPaying: false,
  isPaid: false,
  isFailed: false,
  errorMessage: null,
  confirmUrl: null,
  selectedCardToken: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PAYING:
      return {
        ...state,
        isPaying: true,
      };
    case actionTypes.PAY:
      return {
        ...state,
        isPaying: true,
      };
    case actionTypes.PAY_SUCCESS:
      return {
        ...state,
        isPaying: false,
        isPaid: true,
        isFailed: false,
        errorMessage: null,
        confirmUrl: action.payload.confirmUrl,
      };
    case actionTypes.PAY_FAILED:
      return {
        ...state,
        isPaying: false,
        isPaid: false,
        isFailed: true,
        errorMessage: action.payload.errorMessage,
      };
    case actionTypes.RESET_PAYMENT:
      return {
        ...state,
        ...initialState,
      };
    case actionTypes.SELECT_CARD:
      return {
        ...state,
        selectedCardToken: action.payload.cardToken,
      };
    case actionTypes.CONFIRM: {
      return {
        ...state,
        isPaying: false,
        isPaid: false,
        isFailed: false,
        confirmUrl: null,
      };
    }
    default:
      return state;
  }
};

export default combineReducers({
  [REDUCER_NAME]: reducer,
  [CREDIT_TERMS_REDUCER_NAME]: creditTermsReducer,
});
